import { c as _c } from "react/compiler-runtime";
import { TaxUnit } from "../../../../../models";
import { thousandize } from "../../../../../util/formatting";
import style from "./TaxUnitMobileDetails.module.scss";
export const TaxUnitMobileDetails: React.FC<{
  taxUnit: TaxUnit;
  numberOfDonationsLabel: string;
  sumDonationsLabel: string;
  sumTaxDeductionsLabel: string;
}> = t0 => {
  const $ = _c(31);
  const {
    taxUnit,
    numberOfDonationsLabel,
    sumDonationsLabel,
    sumTaxDeductionsLabel
  } = t0;
  let t1;
  if ($[0] !== numberOfDonationsLabel) {
    t1 = <td>{numberOfDonationsLabel}</td>;
    $[0] = numberOfDonationsLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== taxUnit.numDonations) {
    t2 = thousandize(Math.round(taxUnit.numDonations));
    $[2] = taxUnit.numDonations;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <td>{t2}</td>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <tr>{t1}{t3}</tr>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== sumDonationsLabel) {
    t5 = <td>{sumDonationsLabel}</td>;
    $[9] = sumDonationsLabel;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== taxUnit.sumDonations) {
    t6 = thousandize(Math.round(taxUnit.sumDonations));
    $[11] = taxUnit.sumDonations;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <td>{t6} kr</td>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t5 || $[16] !== t7) {
    t8 = <tr>{t5}{t7}</tr>;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== sumTaxDeductionsLabel) {
    t9 = <td>{sumTaxDeductionsLabel}</td>;
    $[18] = sumTaxDeductionsLabel;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== taxUnit.taxDeductions) {
    t10 = thousandize(Math.round(taxUnit.taxDeductions ? taxUnit.taxDeductions.reduce(_temp, 0) : 0));
    $[20] = taxUnit.taxDeductions;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10) {
    t11 = <td>{t10}{" "}kr</td>;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t9) {
    t12 = <tr>{t9}{t11}</tr>;
    $[24] = t11;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t4 || $[29] !== t8) {
    t13 = <table className={style.table} cellSpacing="0"><tbody>{t4}{t8}{t12}</tbody></table>;
    $[27] = t12;
    $[28] = t4;
    $[29] = t8;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
};
function _temp(acc, deduction) {
  return acc + deduction.deduction;
}